<template>
    <!-- Add Task Modal -->
    <div class="modal fade" id="checkAirFreightModal" ref="checkAirFreightModal" tabindex="-1" aria-labelledby="taskModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="taskModalLabel">
                        {{task ? task.title : ''}}
                    </h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body" v-if="form">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addTask">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">
                                            Carrier Type
                                        </label>
                                        <ValidationProvider name="Carrier Type" rules="required" v-slot="{ errors }">
                                            <select class="form-select" v-model="form.carrier_type">
                                                <option value="3">Partial By Air – Air</option>
                                                <option value="1">Full order by air</option>
                                                <option value="2">Full Shipment by Sea</option>
                                            </select> <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">
                                    Save
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import DatePicker from "vue2-datepicker";
import {mapActions, mapGetters,} from "vuex";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "CheckAirFreightModal",
    props:['order', 'po', 'task', 'loading', 'bus'],
    components:{
        ValidationObserver, ValidationProvider,
        DatePicker
    },
    created() {
    },
    mounted() {
        let self = this;
        if(this.bus) {
            this.bus.$on('triggerCompleteTask', (id) => {
                //self.completeTask(id);
            });
        }

        $("#checkAirFreightModal").on('show.bs.modal', () => {
            if(self.po){
                self.form.purchase_order_id = _.cloneDeep(self.po.id);
            }
            if(self.task){
                self.form.task_id = _.cloneDeep(self.task.id);
            }
            if(self.order) {
                self.form.order_id = _.cloneDeep(self.order.id);
            }
        });

        $('#checkAirFreightModal').on('hidden.bs.modal', function () {
            self.form = {
                order_id: null,
                purchase_order_id: null,
                task_id: null,
                carrier_type: null
            };
            self.$refs.formValidation.reset();
        });
    },
    data(){
        return {
            form: {
                order_id: null,
                purchase_order_id: null,
                task_id: null,
                carrier_type: null
            },
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('po.checkAirFreight', {id: this.po.id}), this.form,{

                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errors && Object.keys(data.errors).length) {
                            self.setCommonErrors(data.errors);
                        } else if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            self.$emit('checkAirFreightUpdated', data);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });

            });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {

    }
}
</script>

<style scoped>

</style>
